import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { AdditionalStyleSheet, OptionalAdditionalStyle } from '../components.utils';
import { MEDIA_BREAKPOINTS } from '../../mediaQueries.const';

export interface AdDataProps {
  id: string | null;
  onSuccess: (() => void) | null;
  dataId?: string;
  setMinHeight?: boolean;
  isSticky?: boolean;
}

export type AdProps = AdDataProps & OptionalAdditionalStyle;

const createStyle = (setMinHeight: boolean) => StyleSheet.create({
  ad: {
    display: 'flex',
    justifyContent: 'center',
    width: '-webkit-fill-available',
    [MEDIA_BREAKPOINTS.large]: {
      minHeight: setMinHeight ? '90px' : 'unset',
    },
    [MEDIA_BREAKPOINTS.medium]: {
      minHeight: 'unset',
    },
    [MEDIA_BREAKPOINTS.small]: {
      minHeight: 'unset',
    },
  },
});

const createStickyBottomStyle = () => StyleSheet.create({
  style: {
    position: 'sticky',
    bottom: 0,
    backgroundColor: 'transparent',
  },
}) as AdditionalStyleSheet;

const getStyleArray = (isStyle: boolean, styleObj?: AdditionalStyleSheet) => {
  return isStyle ? [styleObj?.style] : [];
};

const Placeholder: React.FunctionComponent<AdProps> = ({ id, onSuccess, additionalStyle, dataId, setMinHeight = false, isSticky = false }) => {
  React.useEffect(() => {
    if (onSuccess) {
      try {
        onSuccess();
      } catch (e) {
        console.error(`ClientAPI Error in callback for injecting ad event for ad id: ${id}. Please check the callback value.`, e);
      }
    }
  }, [id, onSuccess]);
  const style = createStyle(setMinHeight);
  const stickyBottomStyle = createStickyBottomStyle();
  const classNames = [style.ad, ...getStyleArray(isSticky, stickyBottomStyle), ...getStyleArray(!!additionalStyle, additionalStyle)];
  const idProp = id ? { id } : {};
  return <div {...idProp} data-mm-id={dataId} data-target="ad" className={css(...classNames)} />;
};
export const Ad: React.FunctionComponent<AdProps> = React.memo(props => {
  const { id, onSuccess, additionalStyle, dataId, setMinHeight = false, isSticky = false } = props;
  return (id || setMinHeight) ? <Placeholder id={id} onSuccess={onSuccess} additionalStyle={additionalStyle} dataId={dataId} setMinHeight={setMinHeight} isSticky={isSticky} /> : null;
});
